import {FC, SVGProps} from "react";

export interface IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isActive?: boolean;
  color?: string;
}

/**
 * A simple component icon with the ability to control the fill color
 * of the icon
 *
 * @param className
 * @param isActive
 * @param color
 * @param props
 * @constructor
 */
export const IconComponent: FC<IconProps> = ({
  className,
  isActive = false,
  color = "#0585c8",
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 16 16"
      className={`svgicon ${className ? `${className} ` : ""}icon-component${
        isActive ? " svgicon--active" : ""
      }`}
      {...props}>
      <g
        className="icon-component-g"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <path
          d="M2.91507915,7.88680012 C2.60572021,7.9605346 2.32582402,7.9457877 2.06065922,7.85730633 C1.89861406,7.79831875 1.72183752,7.75407806 1.54506099,7.70983738 C1.2651648,7.65084979 1,7.85730633 1,8.15224424 L1,10.9394075 C1,11.4850426 1.44194134,11.9274494 1.98700233,11.9274494 L4.78596416,11.9274494 C5.06586034,11.9274494 5.28683101,12.1928936 5.2279055,12.4730846 C5.18371136,12.6647942 5.13951723,12.8565038 5.06586034,13.0482135 C4.97747207,13.3136576 4.96274069,13.6085955 5.03639758,13.9035334 C5.16897999,14.4196748 5.56672719,14.8178409 6.08232542,14.950563 C7.06932775,15.2012602 7.93847906,14.4639154 7.93847906,13.5201141 C7.93847906,13.3578983 7.9090163,13.2104293 7.86482217,13.0629604 C7.80589665,12.8712507 7.74697114,12.6795411 7.70277701,12.4878315 C7.6438515,12.2076405 7.85009079,11.9421963 8.14471835,11.9421963 L10.9436802,11.9421963 C11.4887412,11.9421963 11.9306825,11.4997895 11.9306825,10.9541543 L11.9306825,8.15224424 C11.9306825,7.87205322 12.1958473,7.65084979 12.4757435,7.70983738 C12.6672514,7.75407806 12.8587593,7.79831875 13.0502672,7.87205322 C13.315432,7.9605346 13.6100596,7.97528149 13.9046872,7.90154702 C14.4202854,7.76882496 14.8180326,7.37065878 14.950615,6.85451745 C15.2010484,5.86647546 14.4644795,4.99640863 13.5216713,4.99640863 C13.3596262,4.99640863 13.2123124,5.02590243 13.0649986,5.07014311 C12.8734907,5.12913069 12.6819828,5.18811827 12.4904749,5.23235896 C12.2105787,5.29134654 11.9454139,5.08489001 11.9454139,4.7899521 L11.9454139,1.98804199 C11.9454139,1.44240686 11.5034725,1 10.9584116,1 L1.98700233,1 C1.44194134,1 1,1.44240686 1,1.98804199 L1,4.7752052 C1,5.07014311 1.2651648,5.27659965 1.54506099,5.21761206 C1.72183752,5.17337138 1.88388268,5.12913069 2.06065922,5.07014311 C2.207973,5.02590243 2.35528678,4.99640863 2.51733194,4.99640863 C3.46014013,4.99640863 4.19670903,5.88122235 3.94627561,6.85451745 C3.82842458,7.35591189 3.415946,7.75407806 2.91507915,7.88680012 Z"
          id="icon-component-path"
          fill={color}
          transform="translate(8.000000, 8.000000) scale(-1, 1) rotate(-180.000000) translate(-8.000000, -8.000000) "
        />
      </g>
    </svg>
  );
};
